module.exports = __webpack_public_path__ + "img/schedule.7661020a.svg";